// 9fbef606107a605d69c0edbcd8029e5d
import getAllStores from '@tcp/core/src/queries/getAllStores.query.graphql';
import { executeStatefulGraphQLQuery } from '../../../handler';
import { formatPhoneNumber } from '../../../../utils/formValidation/phoneNumber';
import countriesAndStates from './config/CountriesAndStates';

export const errorHandler = (err) => {
  return err || null;
};

export const getStoreName = (store) =>
  (store.Description && store.Description[0] && store.Description[0].displayStoreName) || '';

export const getBasicInfo = (store) => ({
  basicInfo: {
    id: (store.id || '').trim(),
    storeName: store?.name || '',
    address: {
      addressLine1: store.address1 || '',
      city: store.city || '',
      state: store.state_code || '',
      zipCode: (store.postal_code || '').trim(),
    },
    phone: store.phone ? formatPhoneNumber(store.phone.trim()) : '',
  },
  isGym: store.c_brand ? store.c_brand === 'ALL' : false,
});

export const getStoresByCountry = (country) => {
  const payload = {
    query: getAllStores,
    variables: {
      siteId: `PLACE_${country?.id.toUpperCase()}`,
    },
    type: 'query',
  };

  return executeStatefulGraphQLQuery(payload)
    .then((res) => {
      if (res.data && res.data.getAllStores && res.data.getAllStores.data) {
        const stateMapping = {};
        const storesData = res.data.getAllStores.data;
        storesData.forEach((store) => {
          if (!stateMapping[store.state_code]) {
            stateMapping[store.state_code] = [];
          }
          stateMapping[store.state_code].push(getBasicInfo(store));
        });
        return Object.keys(stateMapping)
          .sort()
          .map((stateId) => {
            // Backend does not have the full state name store so we must map them localy
            const state = countriesAndStates.countriesStatesTable[country.id].find(
              (cState) => cState.id === stateId
            );
            return {
              id: stateId,
              displayName: state ? state.fullName : stateId,
              storesList: stateMapping[stateId],
            };
          });
      }
      return null;
    })
    .catch(errorHandler);
};
